import React from 'react';
import T from 'prop-types';
// styles
import Style from 'style-it';
import classnames from 'classnames/bind';
import styles from './RadioGroup.mod.css';

const cn = classnames.bind(styles);

const RadioGroup = ({
  name,
  className = '',
  options,
  onChange,
  value,
  color,
  vertical,
  id,
  ...otherProps
}) => {
  return (
    <div className={cn(styles.wrapper, { vertical })}>
      {options.map((option, index) => (
        <div key={index} className={cn(styles.radioWrapper, className)} id={id}>
          <Style>
            {`input:checked + span:first-of-type  {
                box-shadow: 0 0 0 1px ${color};
                background-color: ${color};
                border-color: ${color};
              }`}
            <label className={styles.label}>
              <input
                checked={value === option.value}
                name={name}
                type="radio"
                value={option.value}
                onChange={onChange}
                className={styles.input}
                {...otherProps}
              />
              <span className={styles.circle} />
              <span className={styles.textLabel}>{option.label}</span>
            </label>
          </Style>
        </div>
      ))}
    </div>
  );
};

RadioGroup.defaultProps = {
  options: [],
  className: '',
  name: ''
};

RadioGroup.propTypes = {
  name: T.oneOfType([T.string, T.number]),
  options: T.arrayOf(
    T.shape({
      label: T.string.isRequired,
      value: T.oneOfType([T.string, T.number, T.bool]).isRequired
    })
  ),
  value: T.oneOfType([T.string, T.number]),
  onChange: T.func.isRequired,
  className: T.string
};

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/components/RadioGroup/RadioGroup.jsx